import React, { useEffect } from 'react';
import './Toast.scss';

interface ToastProps {
  message: string;
  type?: 'error' | 'success' | 'info';
  onClose: () => void;
  duration?: number;
}

const renderMessageWithUnderlinedEmail = (message: string) => {
  const emailRegex = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gi;
  const parts = message.split(emailRegex);
  
  return parts.map((part, index) => {
    if (emailRegex.test(part)) {
      return (
        <span key={index} style={{ textDecoration: 'underline' }}>
          {part}
        </span>
      );
    }
    return part;
  });
};

export const Toast: React.FC<ToastProps> = ({ 
  message, 
  type = 'error',
  onClose,
  duration = 15000 
}) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [onClose, duration]);

  return (
    <div className={`toast toast--${type}`}>
      <div className="toast__content">
        <span className="toast__message">{renderMessageWithUnderlinedEmail(message)}</span>
        <button className="toast__close" onClick={onClose}>
          ×
        </button>
      </div>
    </div>
  );
};
